import { paths } from '@/paths'

/** Matches backend `AssistantCitation` shape streamed on message_done. */
export interface AssistantCitationLink {
	type: 'store' | 'product' | 'transaction' | 'cabinet'
	id: number
	siteId?: string
	title?: string
	imageUrl?: string
}

export function assistantCitationHref(citation: AssistantCitationLink): string {
	if (citation.type === 'store') return paths.dashboard.stores.details(citation.id)
	if (citation.type === 'transaction') return paths.dashboard.transactions.preview(citation.id)
	if (citation.type === 'cabinet' && citation.siteId) {
		return paths.dashboard.stores.cabinets.details(citation.id, citation.siteId)
	}
	return paths.dashboard.products.details(citation.id)
}

export interface CitationLinkTarget {
	label: string
	href: string
}

/** Build link targets from citations — longest labels first for greedy matching. */
export function buildCitationLinkTargets(citations: AssistantCitationLink[]): CitationLinkTarget[] {
	const byLabel = new Map<string, CitationLinkTarget>()

	for (const citation of citations) {
		const label = citation.title?.trim()
		if (!label || label.length < 2) continue
		if (!byLabel.has(label)) {
			byLabel.set(label, { label, href: assistantCitationHref(citation) })
		}
	}

	return [...byLabel.values()].sort((a, b) => b.label.length - a.label.length)
}
